<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<p class="dedicationText"><em class="italic">For Eva, Nathaniel, and Alexander, with love,<br/> Joseph Kerman, in friendship,<br/> and<br/> Marianne Goldberger, with deep regard</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?0ef8a2ce